module.exports = __webpack_public_path__ + "img/paciente.5c69be00.svg";